import { IssueType } from "@protos/issues/v1/issues";
import { DEPLOYMENT_URL } from "@shared/constants";
import { Finding, TimeLookbackRange, UpdateFindingBody } from "@shared/types";
import {
  _getFindingsParamsFromSearch,
  calculateLookbackSeconds,
} from "@shared/utils";

import { authPut } from "../auth/auth";

export const updateDeploymentFindingsBulk = (
  deploymentId: number,
  searchParams: URLSearchParams,
  timeLookbackRange: TimeLookbackRange,
  issueType: IssueType,
  updates: UpdateFindingBody
) => {
  let queryParams = new URLSearchParams();
  if (searchParams) {
    // Clean up search params
    queryParams = _getFindingsParamsFromSearch(searchParams);
  }
  queryParams.set(
    "since",
    calculateLookbackSeconds(timeLookbackRange).toString()
  );
  if (queryParams.get("tab") === null) {
    queryParams.set("tab", "open");
  }

  switch (issueType) {
    case IssueType.SCA:
      queryParams.set("issue_type", "sca");
      break;
    case IssueType.SAST:
    default:
      queryParams.set("issue_type", "sast");
  }

  return authPut<UpdateFindingBody, Finding[]>(
    `${DEPLOYMENT_URL}/${deploymentId}/issues?${queryParams.toString()}`,
    updates
  );
};
